import { LanguageCode } from 'translations/Language'
import { getOnboardingCTLinks } from 'constants/staticLinks'

export const getOnboardingCTLink = (language: string) => {
  switch (language) {
    case LanguageCode.DE:
      return getOnboardingCTLinks.DE
    case LanguageCode.FR:
      return getOnboardingCTLinks.FR
    case LanguageCode.NL:
      return getOnboardingCTLinks.NL
    case LanguageCode.EN:
    default:
      return getOnboardingCTLinks.EN
  }
}
